module.exports = __webpack_public_path__ + "img/12.22f25a2f.png";